import { UserRole } from './../../common/types/Irmao'
import { Location } from 'vue-router'

export default [
	{
		path: { name: 'home' },
		nome: 'Home',
		icone: 'mdi-home',
		permiteVisitante: true,
	},
	{

		path: { name: 'busca' },
		nome: 'Pesquisar',
		icone: 'mdi-magnify',
		permiteVisitante: true,
	},
	{
		path: { name: 'agenda' },
		nome: 'Agenda',
		icone: 'mdi-calendar-outline',
		permiteVisitante: true,
	},
	{
		path: { name: 'candidatos' },
		nome: 'Candidatos',
		icone: 'mdi-vote',
	},
	{
		path: { name: 'relatorios' },
		nome: 'Relatórios',
		icone: 'mdi-file-pdf-outline',
	},
	{
		path: { name: 'arquivos' },
		nome: 'Arquivos',
		icone: 'mdi-folder-open',
	},
	{
		path: { name: 'admin' },
		nome: 'Administrar',
		icone: 'mdi-cog',
		requires: ['admin', 'admin-loja'],
	},
] satisfies ItemMenu[]

interface ItemMenu {
	nome: string
	icone: string
	path?: Location
	action?: () => void
	requires?: UserRole[]
	permiteVisitante?: boolean
}
